import React, { createContext, useContext, useState, useCallback } from "react";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState(null);

  const openModal = useCallback((content) => setModalContent(() => content), []);
  const closeModal = useCallback(() => setModalContent(null), []);

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}

      {/* 🔹 Modal portal rendered within the provider’s layout */}
      {modalContent && (
        <div
  className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
  onClick={closeModal}
>

          <div
            className="bg-white rounded-2xl shadow-xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            {typeof modalContent === "function"
              ? modalContent({ closeModal })
              : modalContent}
          </div>
        </div>
      )}
    </ModalContext.Provider>
  );
};
